module.exports = __webpack_public_path__ + "static/media/sidebar-bg.9d285e72.jpg";